import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M11 11h1l3 -4l-4 4","key":"svg-1"}],["path",{"d":"M12 13h1l-4 4l3 -4","key":"svg-2"}]]

const IconBrandSocketIo = createReactComponent('outline', 'brand-socket-io', 'BrandSocketIo', __iconNode);

export default IconBrandSocketIo;